// import React, { useEffect, useRef, useState } from "react";
// import ScrollMagic from "scrollmagic";
// import { gsap } from "gsap";
// import devicewrapper from "../../src/assets/new-images/device-wrapper.png";
// import dashboard from "../../src/assets/new-images/Dashboard.png";
// import Collab from "../assets/new-images/collab.png";
// import Task from "../assets/new-images/TaskManag.png";
// import mscreenone from "../../src/assets/new-images/iphone-app.png";

// const slides = [
//   {
//     id: 1,
//     title: "Custom Dashboards, Your Way",
//     description:
//       "Create multiple dashboards with AI-powered insights and customizable widgets to visualize your workflow effortlessly",
//     mobileImage: mscreenone,
//     desktopImage: dashboard,
//   },
//   {
//     id: 2,
//     title: "Seamless Collaboration",
//     description:
//       "Stay connected with your team through integrated chat, document sharing, and real-time updates, all within one platform",
//     mobileImage: mscreenone,
//     desktopImage: Collab,
//   },
//   {
//     id: 3,
//     title: "Task Management Made Simple.",
//     description:
//       "Easily create, assign, and track tasks across your team. With Simplifyte, anybody would know what needs to be done and when.",
//     mobileImage: mscreenone,
//     desktopImage: Task,
//   },
// ];

// const SlideSection = () => {
//   const containerRef = useRef(null);
//   const [activeSlide, setActiveSlide] = useState(0);
//   const imageRef = useRef(null);

//   useEffect(() => {
//     const controller = new ScrollMagic.Controller();
//     const sections = containerRef.current.querySelectorAll(".text-section");

//     sections.forEach((section, index) => {
//       new ScrollMagic.Scene({
//         triggerElement: section,
//         triggerHook: 0.5,
//         duration: section.offsetHeight,
//       })
//         .on("enter", () => {
//           setActiveSlide(index);
//         })
//         .addTo(controller);
//     });

//     return () => controller.destroy();
//   }, []);

//   useEffect(() => {
//     const img = imageRef.current;
//     gsap.fromTo(
//       img,
//       { opacity: 0, scale: 0.95 },
//       { opacity: 1, scale: 1, duration: 0.6, ease: "power2.out" },
//     );
//   }, [activeSlide]);

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-16">
//       {/* Desktop View */}
//       <div className="hidden md:flex flex-row gap-12">
//         {/* Scrollable Text */}
//         <div
//           ref={containerRef}
//           className="md:w-1/2 flex flex-col space-y-[10vh] relative z-10"
//         >
//           {slides.map((slide) => (
//             <div
//               key={slide.id}
//               className="text-section h-screen flex items-center"
//             >
//               <div className="text-design">
//                 <h2 className="text-4xl font-bold text-gray-900 mb-4">
//                   {slide.title}
//                 </h2>
//                 <p className="text-lg text-gray-600 max-w-md">
//                   {slide.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Fixed Image */}
//         <div className="md:w-3/4 sticky top-1/4 h-[500px] flex items-center justify-center">
//           <div className="relative w-full h-full">
//             <img
//               src={devicewrapper}
//               alt="Device Frame"
//               className="absolute inset-0 w-full h-full object-contain pointer-events-none"
//             />
//             <img
//               ref={imageRef}
//               src={slides[activeSlide].desktopImage}
//               alt="Screen"
//               className="absolute inset-[8%] w-[84%] h-[76%] object-cover rounded-lg"
//               // className="absolute inset-[8%] w-auto h-auto object-cover rounded-lg"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Mobile View */}
//       <div className="flex flex-col space-y-12 md:hidden">
//         {slides.map((slide) => (
//           <div key={slide.id} className="flex flex-col items-center">
//             <div className="relative w-full max-w-md">
//               <img
//                 src={slide.mobileImage}
//                 alt="Device Frame"
//                 className="absolute inset-0 w-full h-full object-contain pointer-events-none"
//               />
//               <div className="pt-[130%]" />
//             </div>
//             <div className="text-center m-text-design">
//               <h2 className="text-2xl font-semibold text-gray-900 mb-2">
//                 {slide.title}
//               </h2>
//               <p className="text-base text-gray-600 max-w-xs mx-auto">
//                 {slide.description}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SlideSection;

// import React, { useEffect, useRef, useState } from "react";
// import ScrollMagic from "scrollmagic";
// import { gsap } from "gsap";
// import dashboard from "../../src/assets/new-images/Dashboard.png";
// import Collab from "../assets/new-images/collab.png";
// import Task from "../assets/new-images/TaskManag.png";

// const slides = [
//   {
//     id: 1,
//     title: "Custom Dashboards, Your Way",
//     description:
//       "Create multiple dashboards with AI-powered insights and customizable widgets to visualize your workflow effortlessly",
//     image: dashboard,
//   },
//   {
//     id: 2,
//     title: "Seamless Collaboration",
//     description:
//       "Stay connected with your team through integrated chat, document sharing, and real-time updates, all within one platform",
//     image: Collab,
//   },
//   {
//     id: 3,
//     title: "Task Management Made Simple.",
//     description:
//       "Easily create, assign, and track tasks across your team. With Simplifyte, anybody would know what needs to be done and when.",
//     image: Task,
//   },
// ];

// const SlideSection = () => {
//   const containerRef = useRef(null);
//   const [activeSlide, setActiveSlide] = useState(0);
//   const imageRef = useRef(null);

//   useEffect(() => {
//     const controller = new ScrollMagic.Controller();
//     const sections = containerRef.current.querySelectorAll(".text-section");

//     sections.forEach((section, index) => {
//       new ScrollMagic.Scene({
//         triggerElement: section,
//         triggerHook: 0.5,
//         duration: section.offsetHeight,
//       })
//         .on("enter", () => {
//           setActiveSlide(index);
//         })
//         .addTo(controller);
//     });

//     return () => controller.destroy();
//   }, []);

//   useEffect(() => {
//     const img = imageRef.current;
//     gsap.fromTo(
//       img,
//       { opacity: 0, y: 20 },
//       { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" },
//     );
//   }, [activeSlide]);

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-16">
//       {/* Desktop View */}
//       <div className="hidden md:flex flex-row gap-16 items-start">
//         {/* Scrollable Text */}
//         <div
//           ref={containerRef}
//           className="md:w-1/2 flex flex-col space-y-[10vh] relative z-10"
//         >
//           {slides.map((slide) => (
//             <div
//               key={slide.id}
//               className="text-section h-screen flex items-center"
//             >
//               <div className="text-design">
//                 <h2 className="text-[35px] font-bold text-gray-900 mb-4">
//                   {slide.title}
//                 </h2>
//                 <p className="text-base text-gray-600 max-w-md leading-relaxed">
//                   {slide.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Sticky Image - Clean without device frame */}
//         <div className="md:w-auto sticky top-1/4 h-auto  flex items-center justify-center">
//           <div
//             className="relative w-full h-full flex items-center justify-center
// bg-white/60 backdrop-blur-xl border border-white/30
// rounded-3xl shadow-[0_20px_60px_rgba(0,0,0,0.1)] overflow-hidden"
//           >
//             {/* <div className="absolute inset-0 bg-gradient-to-tr from-indigo-100/40 via-transparent to-blue-100/40 pointer-events-none" /> */}
//             <img
//               ref={imageRef}
//               src={slides[activeSlide].image}
//               alt={slides[activeSlide].title}
//               // className="w-full h-auto max-h-full object-contain rounded-2xl shadow-2xl transition-all duration-500"
//               className="relative z-10 w-[100%] h-auto object-contain rounded-xl transition-all duration-500"
//             />
//           </div>
//         </div>
//       </div>

//       {/* Mobile View */}
//       <div className="flex flex-col space-y-16 md:hidden">
//         {slides.map((slide) => (
//           <div key={slide.id} className="flex flex-col items-center gap-6">
//             <div className="w-full">
//               <img
//                 src={slide.image}
//                 alt={slide.title}
//                 className="w-full h-auto rounded-2xl shadow-lg"
//               />
//             </div>
//             <div className="text-center">
//               <h2 className="text-2xl font-semibold text-gray-900 mb-3">
//                 {slide.title}
//               </h2>
//               <p className="text-base text-gray-600 max-w-xs mx-auto leading-relaxed">
//                 {slide.description}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SlideSection;

import React, { useEffect, useRef, useState } from "react";
import ScrollMagic from "scrollmagic";
import { gsap } from "gsap";
import dashboard from "../../src/assets/new-images/Dashboard.png";
import Collab from "../assets/new-images/collab.png";
import Task from "../assets/new-images/TaskManag.png";
import Events from "../assets/new-images/events.png";
import { ImageWithZoom } from "pure-react-carousel";

const slides = [
  {
    id: 1,
    title: "Custom Dashboards, Your Way",
    description:
      "Personalize dashboards with the metrics, tasks, and updates that matter most to you and your team.",
    // "Create multiple dashboards with AI-powered insights and customizable widgets to visualize your workflow effortlessly",
    image: dashboard,
  },
  {
    id: 2,
    // title: "Task Management Made Simple.",
    title: "Tasks That Stay on Track",
    description:
      "From assigning to completion, manage every task with clarity, accountability, and real-time progress.",
    // "Easily create, assign, and track tasks across your team. With Simplifyte, anybody would know what needs to be done and when.",
    image: Task,
  },
  {
    id: 3,
    title: "Every Hour, Accounted For",
    description:
      "Bring check-ins, overtime, attendance, and leave together in one focused screen built for professional teams.",
    // mobileImage: mscreenone,
    image: Collab,
  },
  {
    id: 4,
    title: "Clarity For What’s Next",
    description:
      "Manage important events, compliance schedules, and reminders from a central page, with quick visibility carried into your dashboard.",
    // mobileImage: mscreenone,
    image: Events,
  },
];

const SlideSection = () => {
  const containerRef = useRef(null);
  const [activeSlide, setActiveSlide] = useState(0);
  const imageRef = useRef(null);

  useEffect(() => {
    const controller = new ScrollMagic.Controller();
    const sections = containerRef.current.querySelectorAll(".text-section");

    sections.forEach((section, index) => {
      new ScrollMagic.Scene({
        triggerElement: section,
        triggerHook: 0.5,
        duration: section.offsetHeight,
      })
        .on("enter", () => {
          setActiveSlide(index);
        })
        .addTo(controller);
    });

    return () => controller.destroy();
  }, []);

  useEffect(() => {
    const img = imageRef.current;
    gsap.fromTo(
      img,
      { opacity: 0, y: 20 },
      { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" },
    );
  }, [activeSlide]);

  return (
    <div className="max-w-7xl mx-auto px-6 py-16">
      {/* Desktop View */}
      <div className="hidden md:flex flex-row gap-16 items-start">
        {/* Scrollable Text */}
        <div
          ref={containerRef}
          className="md:w-2/5 flex flex-col space-y-[1vh] relative z-10 "
        >
          {slides.map((slide) => (
            <div
              key={slide.id}
              className="text-section h-screen flex items-center"
            >
              <div className="text-design">
                <h2 className="text-[35px] font-bold text-gray-900 mb-4">
                  {slide.title}
                </h2>
                <p className="text-base text-gray-600 max-w-md leading-relaxed">
                  {slide.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Sticky Image - Large Premium Card Design */}
        <div className="md:w-3/9 sticky top-1/4 flex items-center justify-center">
          {/* Large Outer Card Container */}
          <div className="w-full max-w-[1200px] mx-auto">
            <div className="rounded-[28px] border border-white-100/50 bg-[linear-gradient(199deg,_#EDEFF3_11.23%,_#E4E7EC_87.61%)] p-[12px] shadow-[0px_20px_40px_-8px_rgba(28,_40,_64,_0.15),_0px_12px_12px_-10px_rgba(28,_40,_64,_0.10),_0px_8px_8px_-8px_rgba(28,_40,_64,_0.14),_0px_0px_0px_1px_#EDEFF3]">
              {/* Inner Card Container */}
              <div className="rounded-[20px] shadow-[0px_4px_12px_0px_rgba(28,_40,_64,_0.08)] bg-white overflow-hidden">
                <img
                  ref={imageRef}
                  src={slides[activeSlide].image}
                  alt={slides[activeSlide].title}
                  className="w-full h-auto rounded-[inherit] bg-primary-background transition-all duration-500 hover:scale-[1.02]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile View */}
      <div className="flex flex-col space-y-16 md:hidden gap-16">
        {slides.map((slide) => (
          <div key={slide.id} className="flex flex-col items-center gap-6">
            <div className="w-full max-w-md mx-auto">
              <div className="rounded-[20px] border border-white-100/50 bg-[linear-gradient(199deg,_#EDEFF3_11.23%,_#E4E7EC_87.61%)] p-[9px] shadow-[0px_10px_30px_-4px_rgba(28,_40,_64,_0.10),_0px_8px_8px_-8px_rgba(28,_40,_64,_0.10),_0px_4px_4px_-6px_rgba(28,_40,_64,_0.14),_0px_0px_0px_1px_#EDEFF3]">
                <div className="rounded-[11px] shadow-[0px_2px_6px_0px_rgba(28,_40,_64,_0.04)] bg-white overflow-hidden">
                  <img
                    src={slide.image}
                    alt={slide.title}
                    className="w-full h-auto rounded-[inherit] bg-primary-background"
                  />
                </div>
              </div>
            </div>
            <div className="text-center">
              <h2 className="text-2xl font-semibold text-gray-900 mb-3">
                {slide.title}
              </h2>
              <p className="text-base text-gray-600 max-w-xs mx-auto leading-relaxed font-normal">
                {slide.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SlideSection;
//

// SLIDE Image code 2 second change
// import React, { useEffect, useRef, useState } from "react";
// import ScrollMagic from "scrollmagic";
// import { gsap } from "gsap";
// import dashboard from "../../src/assets/new-images/Dashboard.png";
// import Collab from "../assets/new-images/collab.png";
// import Task from "../assets/new-images/TaskManag.png";
// import Events from "../assets/new-images/events.png";

// const slides = [
//   {
//     id: 1,
//     title: "Custom Dashboards, Your Way",
//     description:
//       "Personalize dashboards with the metrics, tasks, and updates that matter most to you and your team.",
//     image: dashboard,
//   },
//   {
//     id: 2,
//     title: "Tasks That Stay on Track",
//     description:
//       "From assigning to completion, manage every task with clarity, accountability, and real-time progress.",
//     image: Task,
//   },
//   {
//     id: 3,
//     title: "Every Hour, Accounted For",
//     description:
//       "Bring check-ins, overtime, attendance, and leave together in one focused screen built for professional teams.",
//     image: Collab,
//   },
//   {
//     id: 4,
//     title: "Clarity For What’s Next",
//     description:
//       "Manage important events, compliance schedules, and reminders from a central page, with quick visibility carried into your dashboard.",
//     image: Events,
//   },
// ];

// const SlideSection = () => {
//   const containerRef = useRef(null);
//   const [activeSlide, setActiveSlide] = useState(0);
//   const imageRef = useRef(null);
//   const autoPlayRef = useRef(null);
//   const [isAutoPlaying, setIsAutoPlaying] = useState(true);

//   // Auto-slideshow effect
//   useEffect(() => {
//     if (isAutoPlaying) {
//       autoPlayRef.current = setInterval(() => {
//         setActiveSlide((prevSlide) => (prevSlide + 1) % slides.length);
//       }, 2000); // Change image every 2 seconds
//     }

//     return () => {
//       if (autoPlayRef.current) {
//         clearInterval(autoPlayRef.current);
//       }
//     };
//   }, [isAutoPlaying]);

//   // ScrollMagic effect
//   useEffect(() => {
//     const controller = new ScrollMagic.Controller();
//     const sections = containerRef.current.querySelectorAll(".text-section");

//     sections.forEach((section, index) => {
//       new ScrollMagic.Scene({
//         triggerElement: section,
//         triggerHook: 0.5,
//         duration: section.offsetHeight,
//       })
//         .on("enter", () => {
//           // Stop auto-play when user scrolls to a section
//           setIsAutoPlaying(false);
//           setActiveSlide(index);

//           // Restart auto-play after 5 seconds of inactivity
//           setTimeout(() => {
//             setIsAutoPlaying(true);
//           }, 5000);
//         })
//         .addTo(controller);
//     });

//     return () => controller.destroy();
//   }, []);

//   // GSAP animation effect
//   useEffect(() => {
//     const img = imageRef.current;
//     gsap.fromTo(
//       img,
//       { opacity: 0, y: 20 },
//       { opacity: 1, y: 0, duration: 0.6, ease: "power2.out" }
//     );
//   }, [activeSlide]);

//   // Optional: Add pause/resume controls
//   const toggleAutoPlay = () => {
//     setIsAutoPlaying(!isAutoPlaying);
//   };

//   return (
//     <div className="max-w-7xl mx-auto px-6 py-16">
//       {/* Auto-play indicator (optional) */}
//       <div className="hidden md:flex justify-end mb-4">
//         <button
//           onClick={toggleAutoPlay}
//           className="text-sm text-gray-500 hover:text-gray-700 transition-colors"
//         >
//           {isAutoPlaying ? "⏸ Pause Slideshow" : "▶️ Resume Slideshow"}
//         </button>
//       </div>

//       {/* Desktop View */}
//       <div className="hidden md:flex flex-row gap-16 items-start">
//         {/* Scrollable Text */}
//         <div
//           ref={containerRef}
//           className="md:w-2/5 flex flex-col space-y-[1vh] relative z-10"
//         >
//           {slides.map((slide) => (
//             <div
//               key={slide.id}
//               className="text-section h-screen flex items-center"
//             >
//               <div className="text-design">
//                 <h2 className="text-[35px] font-bold text-gray-900 mb-4">
//                   {slide.title}
//                 </h2>
//                 <p className="text-base text-gray-600 max-w-md leading-relaxed">
//                   {slide.description}
//                 </p>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* Sticky Image - Large Premium Card Design */}
//         <div className="md:w-3/9 sticky top-1/4 flex items-center justify-center">
//           {/* Progress dots (optional) */}
//           <div className="absolute -left-8 flex flex-col gap-2">
//             {slides.map((_, index) => (
//               <button
//                 key={index}
//                 onClick={() => {
//                   setIsAutoPlaying(false);
//                   setActiveSlide(index);
//                   setTimeout(() => setIsAutoPlaying(true), 5000);
//                 }}
//                 className={`w-2 h-2 rounded-full transition-all ${
//                   activeSlide === index
//                     ? "bg-blue-600 w-4"
//                     : "bg-gray-300 hover:bg-gray-400"
//                 }`}
//               />
//             ))}
//           </div>

//           {/* Large Outer Card Container */}
//           <div className="w-full max-w-[1200px] mx-auto">
//             <div className="rounded-[28px] border border-white-100/50 bg-[linear-gradient(199deg,_#EDEFF3_11.23%,_#E4E7EC_87.61%)] p-[12px] shadow-[0px_20px_40px_-8px_rgba(28,_40,_64,_0.15),_0px_12px_12px_-10px_rgba(28,_40,_64,_0.10),_0px_8px_8px_-8px_rgba(28,_40,_64,_0.14),_0px_0px_0px_1px_#EDEFF3]">
//               {/* Inner Card Container */}
//               <div className="rounded-[20px] shadow-[0px_4px_12px_0px_rgba(28,_40,_64,_0.08)] bg-white overflow-hidden">
//                 <img
//                   ref={imageRef}
//                   src={slides[activeSlide].image}
//                   alt={slides[activeSlide].title}
//                   className="w-full h-auto rounded-[inherit] bg-primary-background transition-all duration-500 hover:scale-[1.02]"
//                 />
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile View */}
//       <div className="flex flex-col space-y-16 md:hidden">
//         {slides.map((slide) => (
//           <div key={slide.id} className="flex flex-col items-center gap-6">
//             <div className="w-full max-w-md mx-auto">
//               <div className="rounded-[20px] border border-white-100/50 bg-[linear-gradient(199deg,_#EDEFF3_11.23%,_#E4E7EC_87.61%)] p-[9px] shadow-[0px_10px_30px_-4px_rgba(28,_40,_64,_0.10),_0px_8px_8px_-8px_rgba(28,_40,_64,_0.10),_0px_4px_4px_-6px_rgba(28,_40,_64,_0.14),_0px_0px_0px_1px_#EDEFF3]">
//                 <div className="rounded-[11px] shadow-[0px_2px_6px_0px_rgba(28,_40,_64,_0.04)] bg-white overflow-hidden">
//                   <img
//                     src={slide.image}
//                     alt={slide.title}
//                     className="w-full h-auto rounded-[inherit] bg-primary-background"
//                   />
//                 </div>
//               </div>
//             </div>
//             <div className="text-center">
//               <h2 className="text-2xl font-semibold text-gray-900 mb-3">
//                 {slide.title}
//               </h2>
//               <p className="text-base text-gray-600 max-w-xs mx-auto leading-relaxed">
//                 {slide.description}
//               </p>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default SlideSection;
